import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, registerPackageExport, packageExports, packageName, } = linkedPackage('lincd-auth');
//# sourceMappingURL=package.js.map